export const isValidTime = (time: string) => {
    if(time.length != 5) {
        return false;
    }
    const [hours, minutes] = time.split(":").map(Number);
    if(hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
        return false;
    }
    return true;
};

export const timeToMinutes = (time: string) => {
    if(!isValidTime(time)) {
        return 0;
    }
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
};

export const minutesToTime = (minutes: number) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}`;
};

export interface SubjectInfo {
    id: number;
    schoolId: number;
    name: string;
    url?: string;
}

export interface ScheduleInfo {
    id: number;
    schoolId: number;
    classroomId: number;
    subjectId: number;
    dayOfWeek: number;
    startTime: string;
    endTime: string;
}

export interface SubjectPerformedInfo {
    id: number;
    schoolId: number;
    classroomId: number;
    subjectId: number;
    startedAt?: string;
    endedAt?: string;
    hoursPerformed?: number;
}

export enum PresenceEnum {
    UNKNOWN = 0,
    PRESENT = 1,
    ABSENT = 2,
}

export interface PresenceInfo {
    id: number;
    schoolId: number;
    subjectPerformedId: number;
    studentId: number;
    present: PresenceEnum;
}
